const staffsActionTypes = {
    SET_STAFFS_OBJECT:'SET_STAFFS_OBJECT',
    EDIT_STAFF:'EDIT_STAFF'
}

export default staffsActionTypes